/** Convert a string to Title Case (each word capitalized). */
export function toTitleCase(str: string): string {
  return str
    .split(/[\s_-]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

/** Convert a string to camelCase (first word lowercase, subsequent words capitalized, no spaces). */
export function toCamelCase(str: string): string {
  return str
    .split(/[\s_-]+/)
    .map((word, i) =>
      i === 0
        ? word.toLowerCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join("");
}
